import React, { useEffect, useState} from "react";
import Header from "../components/Header";
import { Link, useLocation } from "react-router-dom";
import { useAxios } from "../services/useAxios";
import { useTranslation } from 'react-i18next';


export default function Category(){
    const { t } = useTranslation();
    const [request] = useAxios();
    const [data, setData] = useState({});
    const lang = localStorage.getItem("language") || "ko";

    const fetchData = async () => {
        const response = await request.post("/app/home/getSaleeCategoryListAPI", {
            nationSeCode : lang
        });
        if(response.data.resultCode === 200){
            console.log(response.data.result);
            setData(response.data.result);        
        }            
    };

    useEffect(() => {
        fetchData();
      }, []);

    return (
        <div>
            <div className="backGround bgBlue"></div>
            <Header type="search" pageTitle={t(`Message.category_title`)}/>
            <ul className="catePageList">
                {data.saleeCategoryList && data.saleeCategoryList
                        .sort(function(a, b){ return a.sort - b.sort}).map((obj, index) => (
                <li className="catePageListLi" key={index}>
                    <div className="titWr">
                    {obj.data?.imageFileNm?   
                    <img src={"https://www.salee.co.kr/com/cmm/getGoodsClImageView.sale?fileNm="+obj.data.imageFileNm} alt={obj.text}/>:''
                    }
                    
                        <Link to={"/Categories/"+obj.id} className="tit">{obj.text}</Link>
                    </div>
                    <ul className="cateDepth2">
                        {obj.childrenList && obj.childrenList.map((obj2, index2) => (
                        <li key={index2}> <Link to={"/Categories/"+obj2.id} className="depth2Link">{obj2.text}</Link></li>
                        
                        ))}                         
                    </ul>
                </li>
                ))}                       
            </ul>
            <div className="hs88"></div>
        </div>
    )
}



